<template lang="pug">
section.visible__layout
  h1.h1-title {{$t('common.myVideos')}}

  spacer(size="50px")

  template(v-if="videos.length === 0")
    empty(action="videos",
          :title="`${$t('noVideosAvail')}`",
          :sup="`${$t('goToDomainVideo').replace(/%domainName%/, currentDomain)}`")
  template(v-else)
    template(v-for="video in videos")
      video-com(:video="video")
      spacer(size="30px")
    //- .pag(v-if="lastPage && lastPage > 1")
      pagination(:current="page", :pages="lastPage", @load="toPage")
</template>

<script>
import API from '@/api/api';
import Empty from '@/components/tickets/empty';
import Video from '@/components/Video';

export default {
  data() {
    return {
      videos: [],
      currentDomain: '',
    };
  },
  mounted() {
    this.getVideos();
    this.currentDomain = window.location.hostname;
  },
  methods: {
    async getVideos() {
      const data = await API.getVideos({
      });
      if (data) {
        this.videos = data.data;
        // console.log(this.videos);
      }
    },
  },
  components: {
    'video-com': Video,
    Empty,
  },
};
</script>

<style lang="scss" scoped>

</style>
